import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import $ from 'jquery';

import {ROOM_TYPE_PERMANENT, ROOM_TYPE_PERSONAL} from '../../../constants/rooms';

import RoomListItem from '../RoomListItem/index';

import RoomInfoTooltip from '../RoomInfoTooltip/index';

import Registry from '../../../registry/index';

class RoomList extends Component {
    constructor(props) {
        super(props);

        this.onItemMouseHover = this.onItemMouseHover.bind(this);
        
    }

    _sortCallback(room1, room2) {
        if (room1.stayed !== room2.stayed) {
            return Number(room2.stayed) - Number(room1.stayed);
        }

        let permanent1 = room1.info.type === ROOM_TYPE_PERMANENT,
            permanent2 = room2.info.type === ROOM_TYPE_PERMANENT;

        let weight1 = (permanent1 ? 100 : 1) * (room1.info.users || 0),
            weight2 = (permanent2 ? 100 : 1) * (room2.info.users || 0);

        return weight1 === weight2 ?
            (room1.info.created - room2.info.created) :
            (weight2 - weight1);
    }

    onItemMouseHover(event, room) {
        event.preventDefault();

        // mouseleave
        if (event.type === "mouseleave") {
            var $toElement = $(event.toElement || event.relatedTarget);

            if ($toElement.parents("li.room.virtual").length) return false;

            this.tooltip.close();
            return false;
        }

        // mouseenter
        var $roomListItem = $(event.target).parents("li");

        if (room.type === ROOM_TYPE_PERMANENT && !room.description) {
            return false;
        }

        this.updateRoomInfoPopup({
            room,
            anchor: $roomListItem,
            ref: (r) => {
                r.open();
            }
        });
        
    }

    updateRoomInfoPopup(props) {
        RoomInfoTooltip.mount(props, (r) => {this.tooltip = r});
    }

    componentDidMount() {
        this.updateRoomInfoPopup();
    }

    render() {
        let {currentUser, currentRoom, users, onRoomChangedMobile, browser, notifications, pm} = this.props,
            currentRoomUsersCount = users.size;

        if (currentRoom.type === ROOM_TYPE_PERSONAL) return null;

        let lang = Registry.get('locale');

        let rooms = this.props.rooms.sort(this._sortCallback);
        rooms = rooms.filter(r => r.info.type !== ROOM_TYPE_PERSONAL);

        let pmWindow = false;
        Object.keys(pm.conversations).map(key => {
           if (pm.conversations[key].view.maximized) {
               pmWindow = true;
           }
        });

        let mainRoomId = Registry.get('chatInterface').getDefaultRoomId();

        return (
                <Fragment>
                    <div>
                        <ul className="room-list">
                            {rooms.map((room) => <RoomListItem key={room.roomid}
                                                            room={room}
                                                            browser={browser}
                                                            currentUser={currentUser}
                                                            currentRoom={currentRoom}
                                                            visible={this.props.visibleRoom === room.roomid}
                                                            currentRoomUsersCount={currentRoomUsersCount}
                                                            mainRoomId={mainRoomId}
                                                            tooltipClose={() => this.tooltip.close()}
                                                            hoverFn={this.onItemMouseHover}
                                                            onRoomChangedMobile={onRoomChangedMobile}
                                                            notificationsWindow={notifications}
                                                            pmWindow={pmWindow}
                            />)}
                        </ul>
                    </div>
                    <p className="refreshing">{lang.refreshing_room_list}</p>
                </Fragment>
        )
    }

}

function mapStateToProps(state, ownProps) {
    let rooms = [];
    for (let roomid in state.rooms) {
        rooms.push(state.rooms[roomid]);
    }
    return {
        visibleRoom: state.visibleChatrooms.roomid,
        currentRoom: state.currentRoom,
        currentUser: state.currentUser,
        rooms: rooms,
        pm: state.pm,
        browser: state.browser,
        // todo: change to currentRoomUserCount prop to prevent frequent DOM updates
        users: state.users,
        notifications: state.notifications.showNotificationsWindow,
    }
}

export default connect(mapStateToProps)(RoomList);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/RoomList/index.js